import React, { useState, useEffect } from "react";
import {
  Button,
  Typography,
  Box,
  CircularProgress,
  Alert,
  Stack,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import "./DashBoard.css";
import ReusableDialog from "../../components/ReusableDialog";
import Nav from "../../components/nav/Nav";
// import { fetchMealData } from "../../Apis/dashboardApis";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { setMealCount, setMealFor } from "../../redux/mealSlice";
import {
  fetchMealHistory,
  selectMealHistory,
  setNeedsRefetch,
} from "../../redux/mealHistorySlice";
import GuestInfoDialog from "./dashboard-dialogs/GuestInfoDialog";
import GuestListDialogs from "./dashboard-dialogs/GuestListDialogs";

const DashBoard = ({ scanData }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { mealHistory, loading, error, needsRefetch } =
    useSelector(selectMealHistory);
  const [isOpen, setIsOpen] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [guestMealCount, setGuestMealCount] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const permission = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user")).permission
    : [];

  useEffect(() => {
    if (needsRefetch || mealHistory.length === 0) {
      dispatch(fetchMealHistory(20));
      dispatch(setNeedsRefetch(false));
    }
  }, [dispatch, needsRefetch, mealHistory.length]);

  const handleGuestScan = () => {
    dispatch(setMealFor("guest"));
    dispatch(setMealCount(guestMealCount));
  };

  const handleSelfScan = () => {
    dispatch(setMealFor("self"));
    dispatch(setMealCount(1));
    navigate("/mobile/scan");
  };
  const hasManageGuestsPermission = permission.some(
    (perm) => perm.permissionName === "manageGuests"
  );

  return (
    <>
      <Nav />
      <BtnArea
        setIsOpen={setIsOpen}
        navigate={navigate}
        hasManageGuestsPermission={hasManageGuestsPermission}
        handleGuestScan={handleGuestScan}
        handleSelfScan={handleSelfScan}
      />
      <MealHistory
        mealHistory={mealHistory}
        loading={loading}
        error={error}
        hasManageGuestsPermission={hasManageGuestsPermission}
        showAll={showAll}
        setShowAll={setShowAll}
      />
      <ReusableDialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        title="dashboard"
        onConfirm={() => setIsOpen(false)}
        setMealCount={setGuestMealCount}
        mealCount={guestMealCount}
        openGuestInfoDialog={() => setDialogOpen(true)}
      />
      <GuestInfoDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
    </>
  );
};

const BtnArea = ({
  setIsOpen,
  navigate,
  hasManageGuestsPermission,
  handleGuestScan,
  handleSelfScan,
}) => {
  return (
    <Box className="Btn-area-main">
      <div className="Btn-area">
        <Box className="btn-area-first-row">
          <Box>
            <Typography variant="h6">Scan to Access Your Services</Typography>
            <Typography>
              Just Scan the QR code <br /> to get Started.
            </Typography>
          </Box>
          <img
            style={{ width: "35%" }}
            src="https://img.freepik.com/premium-vector/send-your-cv-abstract-concept-vector-illustration_107173-24845.jpg"
            alt=""
          />
        </Box>
        {hasManageGuestsPermission ? (
          <Box className="btn-area-get-btns">
            <Button
              variant="outlined"
              sx={{
                background: "white",
                // color: "black",
                // borderColor: "#d4d5d7",
              }}
              size="large"
              onClick={() => {
                setIsOpen(true);
                handleGuestScan();
              }}
            >
              Scan for Guest
            </Button>
            <Button
              variant="contained"
              size="large"
              onClick={() => {
                handleSelfScan();
                navigate("/mobile/scan");
              }}
              color="primary"
            >
              Scan for Self
            </Button>
          </Box>
        ) : (
          <Box className="btn-area-get-btns">
            <Button
              variant="contained"
              onClick={() => {
                handleSelfScan();
                navigate("/mobile/scan");
              }}
              size="large"
              color="primary"
            >
              Scan QR Code
            </Button>
          </Box>
        )}
      </div>
    </Box>
  );
};

const MealHistory = ({
  mealHistory,
  loading,
  error,
  hasManageGuestsPermission,
  showAll,
  setShowAll,
}) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [gustLists, setGuestLists] = useState([]);

  const handleShowAll = () => {
    setShowAll(true);
    dispatch(fetchMealHistory(100));
  };

  const handleShowLess = () => {
    setShowAll(false);
    dispatch(fetchMealHistory(20));
  };

  const handlOpenGuestList = (guests) => {
    setGuestLists(guests);
    setOpen(true);
  };

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="200px"
      >
        <CircularProgress color="primary" />
        <Typography
          variant="body1"
          sx={{ marginTop: "1rem", fontWeight: "500" }}
        >
          Loading meal history...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="200px"
        textAlign="center"
      >
        <Stack spacing={2}>
          <Alert severity="error">{error}</Alert>
        </Stack>
      </Box>
    );
  }

  if (!mealHistory.length) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="200px"
        textAlign="center"
        sx={{
          backgroundColor: "#f9f9f9",
          padding: "2rem",
          borderRadius: "8px",
          margin: "0 20px",
        }}
      >
        <HistoryEduIcon
          color="action"
          sx={{ fontSize: "64px", marginBottom: "0.5rem" }}
        />
        <Typography variant="h6" sx={{ fontWeight: "600" }}>
          No Meal History Found
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Your meal history will appear here once recorded.
        </Typography>
      </Box>
    );
  }

  return (
    <Box className="history-main">
      <Box className="history-header">
        <Typography
          variant="h6"
          sx={{
            // marginBottom: "1rem",
            background: "white",
            paddingTop: "8px",
            paddingLeft: "8px",
            width: "100%",
          }}
        >
          History
        </Typography>
        {mealHistory.length > 20 && (
          <>
            {showAll ? (
              <Button
                variant="text"
                onClick={handleShowLess}
                sx={{ marginBottom: "1rem" }}
              >
                View Less
              </Button>
            ) : (
              <Button
                variant="text"
                onClick={handleShowAll}
                sx={{ marginBottom: "1rem" }}
              >
                View More
              </Button>
            )}
          </>
        )}
      </Box>
      <Box className="history" sx={{ overflow: "scroll" }}>
        {mealHistory?.map((meal, index) => (
          <Box key={index} className="history-box">
            <Box>
              {hasManageGuestsPermission && meal?.mealFor === "guest" && (
                <Typography
                  variant="h6"
                  color="primary"
                  sx={{ cursor: "pointer" }}
                  onClick={() => handlOpenGuestList(meal?.guestInfo)}
                >
                  {`${meal?.mealCount} ${meal["MealType.mealDisplayName"]} for Guest`}{" "}
                  - {meal["Location.displayName"]}
                </Typography>
              )}
              {hasManageGuestsPermission &&
                (meal?.mealFor === "self" || meal?.mealFor === "ctr-self") && (
                  <Typography variant="h6">
                    {` ${meal["MealType.mealDisplayName"]} for Self`} -{" "}
                    {meal["Location.displayName"]}
                  </Typography>
                )}
              {(meal?.mealFor === "self" || meal?.mealFor === "ctr-self") &&
                !hasManageGuestsPermission && (
                  <Typography variant="h6">
                    {meal["MealType.mealDisplayName"]} - {""}
                    {meal["Location.displayName"]}
                  </Typography>
                )}
              <Typography sx={{ color: "gray", fontSize: "0.8rem" }}>
                Taken on: {moment(meal?.createdAt).format("lll")}
              </Typography>
            </Box>
            <CheckCircleIcon sx={{ fontSize: "40px", color: "#3E83C4" }} />
          </Box>
        ))}
      </Box>
      <GuestListDialogs
        open={open}
        onClose={() => setOpen(false)}
        guests={gustLists}
      />
    </Box>
  );
};

export default DashBoard;
